import { render, staticRenderFns } from "./LeavesActivity.vue?vue&type=template&id=08ad222a"
import script from "./LeavesActivity.vue?vue&type=script&lang=js"
export * from "./LeavesActivity.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports